import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Form from './Form';
import s from './styles.module.scss';

class Login extends Component {
  static propTypes = {
    authLogin: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  };

  onSubmit = ({ username, password }) => {
    const { authLogin } = this.props;
    authLogin({ username, password });
  };

  render() {
    const { t } = this.props;
    return (
      <div className={s.root}>
        <div className={s.formContainer}>
          <div className={s.header}>
            <div className={s.imageLogin}>
              <img srcSet="/images/virtues.png 1x, /images/virtues@2x.png 2x" alt="" />
            </div>
            <div className={s.titleLoginWrapper}>
              <h4 className={s.titleLogin}>
                <strong>{t('login.welcome')}</strong>
              </h4>
            </div>
          </div>
          <Form onSubmit={this.onSubmit} />
          <div className={s.imageFooter}>
            {/* <img srcSet="/images/canet.png 1x, /images/canet@2x.png 2x" alt="" /> */}
          </div>
        </div>
        <div className={s.copyright}>
          &copy; Copyright Virtues. Terms of use. <Link to="/privacy-policy">Privacy policy</Link>.
        </div>
      </div>
    );
  }
}

export default withTranslation()(Login);
